import React, { useEffect, useState } from "react";

import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

import { paisesPt } from "../../../utils/helpers/data/countries";
import GroupSegregationSection from "./GroupSegregationSection";

export default function CellphoneInput({
  deleteComponent,
  rowId,
  colId,
  attributes,
  setAttributes,
  autoOpen = false,
  groups = [],
}) {
  const [inputName, setInputName] = useState(
    attributes ? attributes.inputName : "Celular",
  );
  const [label, setLabel] = useState(attributes ? attributes.label : "Celular");
  const [placeholder, setPlaceholder] = useState(
    attributes ? attributes.placeholder : "Digite seu número de Celular",
  );
  const [tipText, setTipText] = useState(
    attributes ? attributes.tipText : "Dica",
  );
  const [hasTip, setHasTip] = useState(attributes ? attributes.hasTip : false);
  // Segregação por grupos — se `groupIds` tiver itens, o campo só é
  // visível pros participantes desses grupos.
  const [groupIds, setGroupIds] = useState(attributes?.groupIds || []);

  // Valor formatado do preview — não é usado no submit (o admin só está
  // configurando o campo), apenas simula visualmente o widget internacional
  // com bandeira + prefixo do país.
  const [phone, setPhone] = useState("");

  // Edit Modal
  const [editModal, setEditModal] = useState(false);

  useEffect(() => {
    if (autoOpen) setEditModal(true);
  }, []);

  useEffect(() => {
    if (!attributes) {
      setAttributes({
        rowId,
        colId,
        attributes: {
          inputName: "Celular",
          label: "Celular",
          placeholder: "Digite seu número de Celular",
          tipText: "Dica",
          hasTip: false,
          required: true,
          hasMask: true,
          mask: "cellphone",
          uniqueField: "cellphone",
          columnValue: "telefone",
        },
      });
    }
  }, [rowId, colId, setAttributes, attributes]);

  const submitForm = (e) => {
    e.preventDefault();
    setAttributes({
      rowId,
      colId,
      attributes: {
        inputName,
        label,
        placeholder,
        tipText,
        hasTip,
        required: true,
        hasMask: true,
        mask: "cellphone",
        uniqueField: "cellphone",
        columnValue: "telefone",
        ...(groupIds.length > 0 ? { groupIds } : {}),
      },
    });
    setEditModal(false);
  };

  return (
    <div>
      <div className="custom-input-container">
        <Modal
          size="lg"
          isOpen={editModal}
          toggle={() => setEditModal(!editModal)}
          centered
        >
          <ModalHeader toggle={() => setEditModal(false)}>
            Configurar Celular
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col>
                <Form>
                  <FormGroup className="input-margin-btm">
                    <Label htmlFor="edit-input-text" className="form-label">
                      Nome do Campo
                    </Label>
                    <Input
                      id="edit-input-text"
                      className="form-control"
                      type="text"
                      value={label}
                      onChange={({ target }) => setLabel(target.value)}
                    />
                  </FormGroup>
                  <FormGroup className="input-margin-btm">
                    <Label
                      htmlFor="edit-input-placeholder"
                      className="form-label"
                    >
                      Texto do placeholder
                    </Label>
                    <Input
                      id="edit-input-placeholder"
                      className="form-control"
                      type="text"
                      value={placeholder}
                      onChange={({ target }) => setPlaceholder(target.value)}
                    />
                  </FormGroup>
                  <FormGroup className="input-margin-btm">
                    <Input
                      className="input-mg-rgt"
                      id="edit-input-has-tip"
                      type="checkbox"
                      checked={hasTip}
                      onChange={({ target }) => setHasTip(target.checked)}
                    />
                    <Label htmlFor="edit-input-has-tip" className="form-label">
                      Possui dica?
                    </Label>
                    {hasTip && (
                      <FormGroup>
                        <Label htmlFor="edit-input-tip" className="form-label">
                          Texto da dica
                        </Label>
                        <Input
                          id="edit-input-tip"
                          className="form-control"
                          type="text"
                          value={tipText}
                          onChange={({ target }) => setTipText(target.value)}
                        />
                      </FormGroup>
                    )}
                  </FormGroup>
                </Form>
                <GroupSegregationSection
                  groups={groups}
                  groupIds={groupIds}
                  onChange={setGroupIds}
                  fieldPrefix={`cellphoneinput-${rowId}-${colId}`}
                />
              </Col>
              <Col style={{ borderLeft: "1px solid gray" }}>
                <div style={{ display: "flex" }}>
                  <Label
                    htmlFor="formText"
                    id="teste-cell"
                    className="form-label"
                  >
                    {label === "Celular" ? (
                      `${label}*`
                    ) : (
                      <div dangerouslySetInnerHTML={{ __html: label }} />
                    )}
                  </Label>
                  {hasTip && (
                    <div>
                      <div className="show-tips" id="cell-tip-input">
                        <span>?</span>
                      </div>
                      <UncontrolledTooltip
                        style={{ backgroundColor: "#6f42c1" }}
                        placement="right"
                        target="cell-tip-input"
                      >
                        {tipText}
                      </UncontrolledTooltip>
                    </div>
                  )}
                </div>
                <PhoneInput
                  defaultCountry="br"
                  value={phone}
                  onChange={(value) => setPhone(value)}
                  countries={paisesPt}
                  inputStyle={{ width: "100%" }}
                />
              </Col>
            </Row>

            <div className="save-btn-form-container">
              <Button
                color="success"
                className="btn btn-success waves-effect waves-light save-btn-form"
                onClick={submitForm}
              >
                Salvar
              </Button>
            </div>
          </ModalBody>
        </Modal>
        <div>
          <div className="displayed-config-container">
            <div className="displayed-label">
              <Label htmlFor="formText" className="form-label">
                {label === "Celular" ? (
                  `${label}*`
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: label }} />
                )}
              </Label>
              {hasTip && (
                <div>
                  <div className="show-tips" id="cell-tip-input-display">
                    <span>?</span>
                  </div>
                  <UncontrolledTooltip
                    style={{ backgroundColor: "#6f42c1" }}
                    placement="right"
                    target="cell-tip-input-display"
                  >
                    {tipText}
                  </UncontrolledTooltip>
                </div>
              )}
            </div>
            <div className="config-form-icon">
              <span
                className="mdi mdi-cog-outline"
                onClick={() => setEditModal(!editModal)}
              />
              <span
                className="mdi mdi-close close-icon"
                title="Remover Campo"
                onClick={() => deleteComponent(rowId, colId)}
              />
            </div>
          </div>
          <PhoneInput
            defaultCountry="br"
            value={phone}
            onChange={(value) => setPhone(value)}
            countries={paisesPt}
            inputStyle={{ width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
}
